import React, { useEffect, useState } from "react";
import { Carousel } from "react-responsive-carousel";
import { bannersFn } from "../../../Services/Home/Banners";
import { useMutation } from "react-query";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowBack } from "@mui/icons-material";
import SearchModal from "../../../Shared/Search";
import WishlistButton from "../../../Shared/WishlistButton";
import Checkout from "../../../Components/Checkout";
import { allFiltersFn } from "../../../Services/Products/AllFilters";
import { Skeleton } from "@mui/material";

const CategoryLandingPage = () => {
  const { state } = useLocation();
  const [data, setData] = useState([]);
  const [banners, setBanners] = useState([]);
  const navigate = useNavigate();
  const { mutate: bannersList } = useMutation(bannersFn, {
    onSuccess: (res) => {
      setBanners(res.data.data);
    },
  });

  useEffect(
    () => {
      state?.from === "data" &&
        bannersList({
          banner_section: "category_banner",
          category_id: state?.categoryId,
        });
    },
    // eslint-disable-next-line
    []
  );

  const { mutate, isLoading } = useMutation(allFiltersFn, {
    onSuccess: (res) => {
      setData(res.data.data.product_list);
    },
  });
  useEffect(() => {
    state?.from === "category" &&
      mutate({
        category_id: state?.categoryId,
        sub_category_id: "",
        brand_id: "",
        color_id: "",
        max_price: "",
        min_price: "",
        max_discount: "",
        min_discount: "",
        rating: "",
      });
    state?.from === "subCategory" &&
      mutate({
        category_id: "",
        sub_category_id: state?.categoryId,
        brand_id: "",
        color_id: "",
        max_price: "",
        min_price: "",
        max_discount: "",
        min_discount: "",
        rating: "",
      });
  }, [state?.categoryId]);

  const fourtyPercent = data?.filter((i) => i?.discount_percent > 40);

  return (
    <>
      <div className="py-4 px-3 shadow h-16 fixed top-0 z-50 bg-white dark:bg-zinc-900 w-full flex justify-between gap-4">
        <span className="flex gap-5 items-center">
          <ArrowBack onClick={() => navigate(-1)} />
          <p className="text-xl text-ellipsis whitespace-nowrap w-40 overflow-hidden font-semibold">
            {state?.categoryName}
          </p>
        </span>
        <span className="flex gap-5 items-center ">
          <SearchModal />
          <WishlistButton /> <Checkout />
        </span>
      </div>

      <div className="my-[65px] bg-zinc-200 dark:bg-zinc-700 min-h-[85vh]">
        {banners?.length !== 0 && (
          <div className="flex justify-center">
            <Carousel
              autoPlay
              showStatus={false}
              showThumbs={false}
              showIndicators={false}
              showArrows={false}
            >
              {banners?.map((banner, index) => {
                return (
                  <div key={index + 1}>
                    <img src={banner.image} alt="" />
                  </div>
                );
              })}
            </Carousel>
          </div>
        )}
        <div className="flex flex-col">
          <p className="absolute pt-10 font-serif font-bold text-2xl text-center w-full">
            {state?.categoryName}
          </p>
          <img
            src="https://pub-8de1a28f49c04a568b19557f02b6129b.r2.dev/Assets/PhoneVersion/images/k.jpg"
            alt=""
            className="w-full"
          />
          <div className="bg-yellow-400 pb-3">
            {isLoading ? (
              <>
                <div className="grid gap-3 grid-cols-3 px-3">
                  {[1, 2, 3, 4, 5, 6].map((product, index) => {
                    return (
                      <div
                        key={index + 1}
                        className="bg-white dark:bg-zinc-900 p-2 rounded"
                        onClick={() =>
                          navigate(`/product/${product.id}/${product.slug}`)
                        }
                      >
                        <Skeleton className="!scale-100 !h-24" />
                        <Skeleton className="!h-5" />
                        <Skeleton className="w-11/12 !h-5" />
                      </div>
                    );
                  })}
                </div>
              </>
            ) : (
              <div className="grid gap-3 grid-cols-3 px-3">
                {data?.slice(0, 9)?.map((product, index) => {
                  return (
                    <div
                      key={index + 1}
                      className="bg-white dark:bg-zinc-900 p-2 rounded"
                      onClick={() =>
                        navigate(`/product/${product.id}/${product.slug}`)
                      }
                    >
                      <img
                        src={product.variant_image}
                        alt=""
                        className="rounded"
                      />
                      <p className="text-sm w-24 overflow-hidden whitespace-nowrap text-ellipsis font-semibold">
                        {product.title}
                      </p>
                      <p className="text-sm text-green-500">
                        From ₹{product.actual_price}
                      </p>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>

        {fourtyPercent?.length !== 0 && (
          <div className="flex flex-col">
            <p className="absolute pt-10 font-serif font-bold text-2xl text-center w-full">
              Upto 40% Discount
            </p>
            <img
              src="https://pub-8de1a28f49c04a568b19557f02b6129b.r2.dev/Assets/PhoneVersion/images/s.jpg"
              alt=""
              className="w-full"
            />
            <div className="bg-[#BB9BFE] pb-3">
              {isLoading ? (
                <div className="grid gap-3 grid-cols-3 px-3">
                  {[1, 2, 3, 4, 5, 6].map((product, index) => {
                    return (
                      <div
                        key={index + 1}
                        className="bg-white dark:bg-zinc-900 p-2 rounded"
                        onClick={() =>
                          navigate(`/product/${product.id}/${product.slug}`)
                        }
                      >
                        <Skeleton className="!scale-100 !h-24" />
                        <Skeleton className="!h-5" />
                        <Skeleton className="w-11/12 !h-5" />
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div className="grid gap-3 grid-cols-3 px-3">
                  {fourtyPercent?.slice(0, 9)?.map((product, index) => {
                    return (
                      <div
                        key={index + 1}
                        className="bg-white dark:bg-zinc-900 p-2 rounded"
                        onClick={() =>
                          navigate(`/product/${product.id}/${product.slug}`)
                        }
                      >
                        <img
                          src={product.variant_image}
                          alt=""
                          className="rounded"
                        />
                        <p className="text-sm w-24 overflow-hidden whitespace-nowrap text-ellipsis font-semibold">
                          {product.title}
                        </p>
                        <p className="text-sm text-green-500">
                          From ₹{product.actual_price}
                        </p>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default CategoryLandingPage;
